module.controller('sampleReceiveTakeFormCtrl', [ '$timeout', '$document', '$scope', '$state', 'planSamplingService', 'alertService', 'dateUtilService', 'ASEBIOL_CONSTANTS', 'Upload', sampleReceiveTakeFormCtrlFn ])

function sampleReceiveTakeFormCtrlFn($timeout, $document, $scope, $state, planSamplingService, alertService, dateUtil, ASEBIOL_CONSTANTS, Upload) {
	var vm = this;
	var vmParent = $scope.ctrl;

	var duration = 1000; // milliseconds
	var offset = 40;

	vm.collapse = true;

	vm.loading = false;

	vm.nonconform = {
			type : {}
	};

	vm.validation = {
			observations : {
				maxlength : 500
			}
	};

	vm.thermoButton = {
			pdf : {}
	};


	function init() {

		if (vmParent.sample && vm.isAdmited()) {

			vm.receiveTemperature = vmParent.sample.receiveTemperature;

			if(vmParent.sample.thermoButton != null)
			vm.thermoButton.pdf.name = "termobotón.pdf";
			vm.thermoButton.pdf.valid = true;
		}
	}
	
	vm.isAdmited = function() {
		if(vmParent.sample.state == SAMPLE_STATE.ADMITED.enumName ||
		   vmParent.sample.state == SAMPLE_STATE.ANALYZING.enumName ||
		   vmParent.sample.state == SAMPLE_STATE.ANALYZED.enumName  
		){
			return true;
		}
		return false;
	}

	vm.submitForm = function() {

		if(vmParent.sample.state == SAMPLE_STATE.TAKEN.enumName){			
			vm.admitSample();
		}

		if(vm.isAdmited()){			
			vm.updateAdmitSample();
		}
	}


	vm.admitSample = function() {
		alertService.showSwtQuestion("Admitir la muestra #" + $scope.ctrl.sample.idSample, function() {
			vm.loading = true;

			var admitModel = {
					receiveTemperature : vm.receiveTemperature,
			};

			if(vmParent.sample.thermoButton){
				admitModel.thermoButtonPDF = vm.thermoButton.pdf.dataPDF;
			}

			planSamplingService.admitSample(vmParent.idPlanSampling, vmParent.idSampling, vmParent.idSample, admitModel).then(function(response) {
				vmParent.reloadData();
				vm.loading = false;
				alertService.showSuccess('Muestra recibida satisfactoriamente');
				vmParent.goTop();
			}, function(response) {
				vm.loading = false;
			});
		});
	}

	vm.updateAdmitSample = function() {
		alertService.showSwtQuestion("Actualizar información de recepción, muestra #" + $scope.ctrl.sample.idSample, function() {
			vm.loading = true;

			var updateAdmitModel = {
					receiveTemperature : vm.receiveTemperature,
			};


			if(vmParent.sample.thermoButton){
				updateAdmitModel.thermoButtonPDF = vm.thermoButton.pdf.dataPDF;
			}

			planSamplingService.updateAdmitSample(vmParent.idPlanSampling, vmParent.idSampling, vmParent.idSample, updateAdmitModel).then(function(response) {
				vmParent.reloadData();
				vm.loading = false;
				alertService.showSuccess('Información actualizada satisfactoriamente');
				vmParent.goTop();
			}, function(response) {
				vm.loading = false;
			});
		});
	}

	vm.nonconformSample = function() {
		alertService.showSwtWarningQuestion("Muestra #" + $scope.ctrl.sample.idSample + " no conforme", function() {
			vm.loading = true;

			var nonconformModel = {
					observations : vm.nonconform.observations,
					idNonconformingType : vm.nonconform.type.selected[0].id
			};

			planSamplingService.nonconformSample(vmParent.idPlanSampling, vmParent.idSampling, vmParent.idSample, nonconformModel).then(function(response) {
				vmParent.reloadData();
				vm.loading = false;
				alertService.showSuccess('Muestra recibida es estado NO Conforme satisfactoriamente');
				vmParent.goTop();
			}, function(response) {
				vm.loading = false;
			});
		});
	}

	vm.getTermobuttonData = function(fileSelect, errFiles) {
		vm.errFile = errFiles && errFiles[0];
		// console.log(vm.errFile);
		if (vm.errFile) {
			vm.errFile.detail = "";
			if (vm.errFile.$error == "maxSize") {
				vm.errFile.detail = "El archivo supera el máximo de " + vm.errFile.$errorParam;
			} else if (vm.errFile.$error == "pattern") {
				vm.errFile.detail = "Solo se permiten archivos pdf";
			}
		}
		if (fileSelect) {
			fileSelect.valid = false;
			fileSelect.loading = true;
			fileSelect.upload = Upload.dataUrl(fileSelect, true);
			fileSelect.upload.then(function(response) {
				fileSelect.dataPDF = response;
				fileSelect.loading = false;
				fileSelect.valid = true;
				// console.log(fileSelect)
				// console.log(response)

			});
		}
	}

	vm.isExpanded = function() {
		$timeout(scrollToReceiveForm, 100);
	}

	vm.isCollapsed = function() {
		if (angular.isUndefined(vmParent.sample))
			return;
		if (vmParent.sample.state != SAMPLE_STATE.TAKEN.enumName)
			return;
		$timeout(scrollToTake, 100);
	}

	function validThermobuttonInfo() {
		if (isEmpty(vm.takenInfo.thermoButton.text))
			return true;
		return vm.takenInfo.thermoButton.pdf.valid;
	}

	function scrollToTake() {
		var takeElement = {};
		takeElement = angular.element(document.getElementById('take'));
		$document.scrollToElement(takeElement, offset, duration);
	}

	function scrollToReceiveForm() {
		var takeElement = angular.element(document.getElementById('nonConformingForm'));
		$document.scrollToElement(takeElement, offset, duration);
	}

	init();

}